import {ITimeService} from './time.service.interface';
import {ServiceBase} from "../ServiceBase";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {makeObservable, observable, runInAction} from "mobx";
import {Check, TimeSpan} from "@sparkware/app-utils";
import {namedSetInterval} from "../../../common/utils/time-functions";

export class TimeService extends ServiceBase implements ITimeService {

  constructor(services: IServiceFactoryExtended) {
    super(services);

    makeObservable(this);

    this._readServerTime();

    namedSetInterval('CLOCK_INCREMENT_INTERVAL_TIMER', () => {
      runInAction(() => {
        this._currentDate = new Date(this._currentDate.getTime() + 1000);
      });

    }, 1000);

    setInterval(async () => {
      await this._readServerTime();
    }, TimeSpan.fromMinutes(5).totalMilliseconds);

    this.services.sdk.events.onAppResumed(async () => {
      await this._readServerTime();
    })
  }

  @observable.ref
  private _currentDate: Date = new Date();
  getCurrentDate(): Date {
    return this._currentDate;
  }

  now(): number {
    return this.getCurrentDate().getTime();
  }


  private async _readServerTime(): Promise<void> {
    try {
      const response = await this.services.api.clockController.getCurrentServerTime();
      let serverTime = response.ServerTime;
      if(!serverTime.endsWith('Z')) {
        serverTime += 'Z';
      }

      const newDateTime = new Date(serverTime);

      if(Check.isDate(newDateTime)) {
        runInAction(() => {
          this._currentDate = newDateTime;
        })
      }
    } catch (error) {
      this.services.logger.error('Failed to read server time:', error);
    }
  }

  getTimezoneOffset(): number {
    return (new Date().getTimezoneOffset() / 60) * (-1);
  }
}